import React from "react";

import "./ProfileCard.css";

export const ProfileCard = ({image, alertCount,setContext, title, path, navigateTo}) => {

    const handleCardClick = () => {
        if (path === "myProblems"){
            setContext((prevState) => ({
                ...prevState,
                currentScreen: "myProblems",
                activeSection: "My Problems",
            }));
        }else {
            navigateTo(path);
        }
    }

    return (
        <div className="profile-card-container" aria-label={"card-button"} onClick={handleCardClick}>
            <div className="profile-card-icon-container">
                {image}
            </div>
            <div className="profile-card-alert-count-container">
                <p>{alertCount}</p>
            </div>
            <div className="profile-card-title-container">
                <p>{title}</p>
            </div>
        </div>
    );
}
